import { render, staticRenderFns } from "./dilu-uploadfile.vue?vue&type=template&id=bda923c4&scoped=true"
import script from "./dilu-uploadfile.vue?vue&type=script&lang=js"
export * from "./dilu-uploadfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda923c4",
  null
  
)

export default component.exports